<template>
  <div class="common-layout">
    <el-container style="min-height: 100vh">
      <el-header style="padding: 0">
        <el-affix :offset="0">
          <HeaderModule />
        </el-affix>
      </el-header>
      <el-main
        style="
          padding: 0;
          margin-top: -60px;
          background-color: rgba(245, 247, 250, 0.5);
        "
      >
        <div class="theme" :style="{ backgroundImage: 'url(' + picture + ')' }" style="background-size:100% 50vh">
          <el-text tag="b" class="theme-text theme-title">{{ blogTitle }}</el-text
          ><br />
          <el-text tag="b" class="theme-text theme-body"
            >——{{ author }}</el-text
          >
        </div>
        
        <div class="md" style="display: flex;justify-content: space-between; margin-left: auto; margin-right: auto; width: 90%; margin-top: 40px;margin-bottom: 40px;">
          <div class="ml"  style="width: 14%; max-height: 100%;">
            <el-affix target=".ml" :offset="offset">
          <div style=" width: 100%;">
            <div style="padding: 10px 20px; background-color: #FFFFFF;border-radius: 10px;" >
              <el-text size="large"><el-icon><List /></el-icon>目录</el-text>
              <el-divider />
              <el-scrollbar :height="gd">
              <MdCatalog  editorId="id" :scrollElement="scrollElement" />
            </el-scrollbar>
            </div>
          </div>
            </el-affix>
        </div>
          <div style="width: 60%;">
            <div class="title">
              <h3 style="margin: 0" >{{ blogTitle }}</h3>
            </div>
            <MdPreview editorId="id" :modelValue="text" previewTheme="cyanosis" />
          </div>
          <div style="background-color: #FFFFFF; width: 25%; max-height: 650px;border-radius: 10px;">
            <div style="padding: 10px 20px;">
              <el-text size="large"><el-icon><StarFilled /></el-icon>推荐博文</el-text>
              <el-divider />
              <el-row style="margin-top: 10px;">
                <el-col :span="24" style="margin-top: 5%" v-for="item in recommendedBlog" :key="item.id">
                  <el-link class="tjlink" type="info" @click="openInfo(item.id)">
                    <el-text size="large" line-clamp="1"><SvgIcon v-if="item.readingQuantity > 100" iconName="icon-remen" style="margin-right: 5px;"></SvgIcon>{{ item.title }}</el-text>                  
                    <el-text size="large">
                      <el-icon>
                        <View />
                      </el-icon>
                      {{ item.readingQuantity }}
                    </el-text>
                  </el-link>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        
        
      </el-main>
      <el-footer>
        <FooterModule />
      </el-footer>
    </el-container>
  </div>
  <BackTop />
  <BackGround style="position: absolute; z-index: -1" />
</template>
    
  <script>
import { onMounted, ref } from "vue";
import {MdPreview,MdCatalog  } from "md-editor-v3";
import "md-editor-v3/lib/style.css";
import {findArticle,articleAddReadingQuantity,findRecommendedBlog} from '@/api/api';
import { useRoute,useRouter } from 'vue-router';
export default {
  components: { MdPreview,MdCatalog },
  setup() {
    const text = ref('');
    const blogTitle = ref('');
    const author = ref('');
    const picture = ref('');
    const scrollElement = document.documentElement;
    const route = useRoute();
    const router = useRouter();
    const recommendedBlog = ref([]);
    const offset = (window.innerHeight*0.5)+41;
    const gd = window.innerHeight-offset-100
    console.log(window.innerHeight)
    console.log(offset)
    console.log(gd)

    const openInfo = (id) => {
      const url = `/BlogInfo/${id}`; // 假设这是你的应用内部的相对URL
      const fullUrl = window.location.origin + url; // 转换为完整的URL
      window.open(fullUrl, '_blank'); // 在新标签页中打开
    };

    onMounted(async () => {
      findArticle({ id: route.params.id})
          .then((response) => {
            if(response.data === null || response.data === undefined || response.data === ''){
              router.push(`/404`)
            }
            blogTitle.value = response.data.title;
            text.value = response.data.bodyMd;
            author.value = response.data.creationBy;
            picture.value = response.data.picture
          })
          .catch(() => {
          });
      articleAddReadingQuantity({ id: route.params.id})
      findRecommendedBlog({ id: route.params.id})
          .then((response) => {
            recommendedBlog.value = response.data;
          })
          .catch(() => {
          });
    })
    return {
      MdPreview,
      MdCatalog,
      openInfo,
      text,
      blogTitle,
      author,
      picture,
      scrollElement,
      recommendedBlog,
      offset,
      gd
    };
  },
};
</script>
    
<style scoped>
.theme {
  height: 50vh;
  width: 100%;
   /* 确保路径正确 */
  background-size: cover; /* 图片将尽可能大地覆盖整个容器，可能会被裁剪 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 不重复 */
  display: flex; /* 启用Flexbox布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  flex-direction: column; /* 如果需要子元素垂直排列（在这个例子中不是必需的，但可以用于其他布局）*/
}
.theme h1 {
  margin: 0; /* 可能需要移除默认的margin来确保更精确的居中 */
}
@font-face {
  font-family: "MyCustomFont";
  src: url("../../assets/font/luzhongmocaishou.ttf") format("opentype");
}
.theme-text {
  font-family: "MyCustomFont", sans-serif;
  background-image: linear-gradient(to right, #ecf571, #f311af, #2ec4b6,#67C23A); /* 渐变方向为从左到右，颜色从#ff7e5f渐变到#feb47b */
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  letter-spacing: 4px;
}
.theme-title {
  font-size: 40px;
}
.theme-body {
  font-size: 20px;
}
.md-editor-previewOnly{
  border-radius: 0 0 10px 10px
}
 .title{
  background-color: #ffffff;
  border-radius: 10px 10px 0 0;
  text-align: center;
  font-size: 2em;
 }
 .tjlink{
  width: 100%;
 }
 :deep(.tjlink .el-link__inner){
  font-size: 18px;
  display: flex; 
  justify-content: space-between; 
  align-items: center;
  width: 100%;
 }
</style>